import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const PyCharmLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.8343 3.77148L23.8286 9.63434L21.3257 14.7429L17.0743 13.5772H13.44L16.8343 3.77148Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M9.77143 7.57714L8.4 14.7429L8.26286 17.2114L4.86857 18.6857L0 19.2L1.47429 3.66857L10.2514 0L15.6686 3.56571L9.77143 7.57714Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M9.77143 7.57715L10.4229 21.4286L8.22857 24L0 19.2L6.75429 9.12001L9.77143 7.57715Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M18.8229 6.54857H10.4914L17.8629 0L18.8229 6.54857Z" fill={`url(#paint3_linear_${id})`} />
            <path
                d="M24 21.4629L16.6629 23.9657L6.92571 21.2229L9.77143 7.57714L10.9029 6.54857L16.8343 6L16.2857 11.9657L21.0171 10.1486L24 21.4629Z"
                fill={`url(#paint4_linear_${id})`}
            />
            <path d="M19.4057 4.59424H4.59428V19.4057H19.4057V4.59424Z" fill="black" />
            <path d="M11.5543 16.6285H6V17.5543H11.5543V16.6285Z" fill="white" />
            <path
                d="M5.93143 6.54858H8.43428C9.90857 6.54858 10.8 7.40573 10.8 8.6743V8.70858C10.8 10.1143 9.70286 10.8686 8.33143 10.8686H7.30286V12.6857H5.96571V6.54858H5.93143ZM8.36571 9.6343C9.05143 9.6343 9.42857 9.22287 9.42857 8.70858V8.6743C9.42857 8.05716 9.01714 7.74858 8.33143 7.74858H7.30286V9.6343H8.36571Z"
                fill="white"
            />
            <path
                d="M11.3486 9.63425C11.3486 7.88568 12.6514 6.44568 14.5371 6.44568C15.7029 6.44568 16.3886 6.82282 16.9714 7.40568L16.1143 8.39996C15.6343 7.95425 15.1543 7.71425 14.5371 7.71425C13.5086 7.71425 12.7543 8.57139 12.7543 9.63425V9.59996C12.7543 10.6628 13.4743 11.52 14.5371 11.52C15.2229 11.52 15.6686 11.2457 16.1486 10.8L17.0057 11.6571C16.3886 12.3428 15.6686 12.7543 14.5029 12.7543C12.6857 12.7885 11.3486 11.3828 11.3486 9.63425Z"
                fill="white"
            />

            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="8.57091"
                    y1="9.273"
                    x2="22.8537"
                    y2="9.273"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21D789" />
                    <stop offset="1" stopColor="#07C3F2" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="-8.42037"
                    y1="20.2562"
                    x2="20.9896"
                    y2="-1.45416"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0107527" stopColor="#FCF84A" />
                    <stop offset="0.1116" stopColor="#A7EB62" />
                    <stop offset="0.2056" stopColor="#5FE077" />
                    <stop offset="0.2727" stopColor="#32DA84" />
                    <stop offset="0.3065" stopColor="#21D789" />
                    <stop offset="0.5768" stopColor="#21D789" />
                    <stop offset="0.5968" stopColor="#21D789" />
                    <stop offset="0.686" stopColor="#20D68C" />
                    <stop offset="0.7627" stopColor="#1ED497" />
                    <stop offset="0.8348" stopColor="#19D1A9" />
                    <stop offset="0.904" stopColor="#13CCC2" />
                    <stop offset="0.9707" stopColor="#0BC6E1" />
                    <stop offset="1" stopColor="#07C3F2" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="3.19889"
                    y1="26.6241"
                    x2="8.10408"
                    y2="11.2319"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21D789" />
                    <stop offset="0.1638" stopColor="#24D788" />
                    <stop offset="0.3047" stopColor="#2FD886" />
                    <stop offset="0.4371" stopColor="#41DA82" />
                    <stop offset="0.5644" stopColor="#5ADC7D" />
                    <stop offset="0.6881" stopColor="#7AE077" />
                    <stop offset="0.809" stopColor="#A1E36E" />
                    <stop offset="0.9254" stopColor="#CFE865" />
                    <stop offset="1" stopColor="#F1EB5E" />
                </linearGradient>
                <linearGradient
                    id={`paint3_linear_${id}`}
                    x1="9.69439"
                    y1="13.2422"
                    x2="20.3687"
                    y2="-1.10942"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21D789" />
                    <stop offset="0.0608105" stopColor="#24D788" />
                    <stop offset="0.1131" stopColor="#2FD886" />
                    <stop offset="0.1622" stopColor="#41DA82" />
                    <stop offset="0.2094" stopColor="#5ADD7D" />
                    <stop offset="0.2548" stopColor="#79E077" />
                    <stop offset="0.2581" stopColor="#7CE076" />
                    <stop offset="0.4986" stopColor="#8CE173" />
                    <stop offset="0.9247" stopColor="#B2E56B" />
                </linearGradient>
                <linearGradient
                    id={`paint4_linear_${id}`}
                    x1="26.0192"
                    y1="15.0684"
                    x2="4.51128"
                    y2="14.8693"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.3871" stopColor="#FCF84A" />
                    <stop offset="0.5358" stopColor="#ECF451" />
                    <stop offset="0.8259" stopColor="#C2E964" />
                    <stop offset="0.9247" stopColor="#B2E56B" />
                </linearGradient>
            </defs>
        </svg>
    );
};
